"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateTenant = exports.tenantSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const tenantSchema = exports.tenantSchema = zod.string().regex(/^[A-Za-z]{2}$/).transform(val => val.toLowerCase());

/**
 * Validates the provided tenant against the tenant schema.
 *
 * @param tenant - The tenant to validate. It can be undefined.
 * @returns The lowercased validated tenant if the validation is successful, otherwise undefined.
 */
const validateTenant = tenant => {
  const result = tenantSchema.safeParse(tenant);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validateTenant = validateTenant;
//# sourceMappingURL=validateTenant.js.map